import React from 'react';
import NAMES from '~/constants/NAMES';
import DialogPrivacyPolicy from '../DialogPrivacyPolicy';
import DialogTermsOfUse from '../DialogTermsOfUse';
import { StyledFooter, StyledLink, StyledTypography, StyledUl } from './styles';
export interface FooterProps {
  style?: React.CSSProperties;
}
const Footer: React.FC<FooterProps> = ({
  style
}: FooterProps): React.ReactElement => {
  const [termsOfUseDialogIsOpen, setTermsOfUseDialogIsOpen] = React.useState(false);
  const [privacyPolicyDialogIsOpen, setPrivacyPolicyDialogIsOpen] = React.useState(false);
  const FOOTER_ITEMS = [{
    onClick: (): void => {
      setTermsOfUseDialogIsOpen(true);
    },
    title: `${NAMES.APP}  Terms of Use`
  }, {
    onClick: (): void => {
      setPrivacyPolicyDialogIsOpen(true);
    },
    title: 'ACT Privacy Policy'
  }, {
    title: `©${new Date().getFullYear()} by ${NAMES.COMPANY} All rights reserved.`
  }];
  return <StyledFooter style={style} data-sentry-element="StyledFooter" data-sentry-component="Footer" data-sentry-source-file="index.tsx">
      <StyledUl data-sentry-element="StyledUl" data-sentry-source-file="index.tsx">
        {FOOTER_ITEMS.map(item => <li key={item.title}>
            {item.onClick ? <StyledLink href="#" onClick={item.onClick} variant="caption">
                {item.title}
              </StyledLink> : <StyledTypography variant="caption">
                {item.title}
              </StyledTypography>}
          </li>)}
      </StyledUl>

      <DialogTermsOfUse onClose={(): void => {
      setTermsOfUseDialogIsOpen(false);
    }} open={termsOfUseDialogIsOpen} data-sentry-element="DialogTermsOfUse" data-sentry-source-file="index.tsx" />

      <DialogPrivacyPolicy onClose={(): void => {
      setPrivacyPolicyDialogIsOpen(false);
    }} open={privacyPolicyDialogIsOpen} data-sentry-element="DialogPrivacyPolicy" data-sentry-source-file="index.tsx" />
    </StyledFooter>;
};
export default Footer;